import React from "react";
import { useNavigate } from "react-router-dom";
import BeerBrewMachine from "../../../assets/homePage/beer-brew-machine.png";
import BeerFillingGlass from "../../../assets/homePage/beer-filling-glass-new.jpg";
import {
  AboutUsWrapper,
  ImagesColumn,
  ImageLeft,
  ImageRight,
  RightColumn,
  TopLayer,
  AboutUsSubtitle,
  AboutUsDescription,
  ExploreButton,
  MiddleLayer,
  StaticText,
  BottomLayer,
} from "./aboutUs.styles";

const AboutUs: React.FC = () => {
  const navigate = useNavigate();
  const orgId = localStorage.getItem("orgId") || "";

  const handleExploreNow = () => {
    navigate(`/maltora-customer/products`);
  };

  return (
    <AboutUsWrapper>
      {/* Left images */}
      <ImagesColumn>
        <ImageLeft src={BeerBrewMachine} alt="Beer brewing machine" />
        <ImageRight src={BeerFillingGlass} alt="Beer filling glass" />
      </ImagesColumn>

      {/* Right content*/}
      <RightColumn>
        {/* Layer 1 */}
        <TopLayer>
          <AboutUsSubtitle>ABOUT US</AboutUsSubtitle>
          <AboutUsDescription>
            Maltora is built for modern beverage businesses selling beer, kegs,
            and other drink offerings online. As customer expectations evolve,
            businesses need more than just great products. They need a seamless
            way to manage listings, availability, inventory, and the overall
            buying experience.
          </AboutUsDescription>
          <ExploreButton variant="contained" onClick={handleExploreNow}>
            Explore Now
          </ExploreButton>
        </TopLayer>

        {/* Layer 2 */}
        <MiddleLayer>
          <StaticText>
            Designed for breweries, keg sellers, taprooms, and beverage-focused
            F&B brands, Maltora helps simplify operations and create a smoother
            digital journey for customers. From showcasing products clearly to
            streamlining backend workflows, Maltora helps businesses sell
            smarter and grow with confidence.
          </StaticText>
        </MiddleLayer>

        {/* Layer 3 */}

        <BottomLayer />
      </RightColumn>
    </AboutUsWrapper>
  );
};

export default AboutUs;
